/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Guidevideo_Delete_Aria1Inputs */

const vi_guidevideo_delete_aria1 = /** @type {(inputs: Guidevideo_Delete_Aria1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xoá video ${i?.title}`)
};

/**

* @param {Guidevideo_Delete_Aria1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_delete_aria1 = /** @type {((inputs: Guidevideo_Delete_Aria1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Delete_Aria1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_delete_aria1(inputs)
});
export { guidevideo_delete_aria1 as "guideVideo_delete_aria" }